















import { Component, Vue } from 'vue-property-decorator';
import { map, flatten, forEach, find, filter } from 'lodash';

import Stage from '@flow/engine';
import Store from '@/store';

import StageModule from '@/store/modules/stage';
import * as APITypes from '../../../shared/src/models/Stage';

declare global {
  interface Window {
    dataLayer: any[];
    ga: Function;
  }
}

@Component({
  components: {
    Stage,
  },
})
export default class Index extends Vue {
  public layerTemplate: object[] = [];
  public playerTemplate: object[] = [];
  private currentProjectID: number | undefined;
  private currentPlayerLayerID: number | undefined;
  private playerTourID: number | undefined;
  public timer: number | undefined;
  public playerTimer: number | undefined;

  updateScene(val: string, currentScene: object) {
    clearInterval(this.timer);
    clearInterval(this.playerTimer);

    this.$router.push({ query: { sceneId: val } });

    const updateLayer = this.setFindLayers([currentScene]);
    this.sendGTMModuleView(updateLayer);
    this.sendGTMModuleTime();
  }

  onPlayerSceneChange({ beforeScene, nowScene }) {
    // gtm 이벤트 추가 - 최초 Scene 호출 시 첫번째 Layer 이벤트 발생
    this.playerTemplate = [];
    this.playerTourID = nowScene.tourID;
    this.currentPlayerLayerID = nowScene.layers[0].id;

    /* eslint-disable */
    const template = {
      'event': 'moduleVRPlayerLayerViewEvent',
      'categoryProjectID': this.currentProjectID,
      'categoryStageID': this.$route.params.stageId,
      'categoryTourID': nowScene.tourID,
      'action': 'VRPlayer_Layer_View',
      'labelSceneID': nowScene.id,
      'labelLayerID': nowScene.layers[0].id
    };

    this.playerTemplate.push(template);

    if (this.playerTourID) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(template);

      this.sendGTMPlayerTime(nowScene);
    }
  }

  onPlayerLayerChange({ nowScene, nowLayer }) {
    // gtm 이벤트 추가 - Layer 변경시 시 이벤트 발생
    this.currentPlayerLayerID = nowLayer.id;
    this.playerTourID = nowScene.tourID;

    const template = {
      'event': 'moduleVRPlayerLayerViewEvent',
      'categoryProjectID': this.currentProjectID,
      'categoryStageID': this.$route.params.stageId,
      'categoryTourID': nowScene.tourID,
      'action': 'VRPlayer_Layer_View',
      'labelSceneID': nowScene.id,
      'labelLayerID': this.currentPlayerLayerID,
    };

    if (this.playerTourID) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(template);

      this.sendGTMPlayerTime(nowScene);
    }
  }

  onPlayerHotspotTrigger({ hotspotData }) {
    // gtm 이벤트 추가 - 핫스팟 클릭시 이벤트 발생
    const template = {
      'event': 'moduleVRPlayerHotspotEvent',
      'categoryProjectID': this.currentProjectID,
      'categoryStageID': this.$route.params.stageId,
      'categoryTourID': this.playerTourID,
      'action': 'VRPlayer_Hotspot',
      'labelSceneID': hotspotData.sceneID,
      'labelHotspotType': hotspotData.hotspotType,
      'labelHotspotID': hotspotData.id,
    };

    if (this.currentProjectID && hotspotData.sceneID) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(template);
    }
  }

  updateLayer(layer: APITypes.Layer) {
    this.sendGTMModuleView([layer]);
  }

  sendGTMModuleView(layers) {
    this.layerTemplate = [];
    forEach(flatten(layers), (layer: any) => {
      if (layer.module.projectID) this.currentProjectID = layer.module.projectID;

      const template = {
        'event': 'moduleViewEvent',
        'categoryProjectID': this.currentProjectID,
        'categoryStageID': this.$route.params.stageId,
        'action': 'Module_View',
        'labelModuleID': layer.module.id,
        'labelModuleType': layer.module.type,
        'labelModuleName': layer.module.name
      };

      this.layerTemplate.push(template);

      if (this.currentProjectID) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(template);
      }
    });
  }

  sendGTMModuleTime() {
    if (this.currentProjectID) {
      this.timer = window.setInterval(() => {

        forEach(flatten(this.layerTemplate), (layer: any) => {
          const template = layer;
          template.event = 'moduleTimeEvent';
          template.action = 'Module_Time';
          template.valueTime = 15000 / 1000;

          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push(template);
        });
      }, 15000);
    }
  }

  sendGTMPlayerTime(tourScene) {
    this.playerTimer = window.setInterval(() => {

      if (this.currentProjectID && this.playerTourID) {
        const template = {
          'event': 'moduleVRPlayerLayerTimeEvent',
          'categoryProjectID': this.currentProjectID,
          'categoryStageID': this.$route.params.stageId,
          'categoryTourID': this.playerTourID,
          'action': 'VRPlayer_Layer_Time',
          'labelSceneID': tourScene.id,
          'labelLayerID': this.currentPlayerLayerID,
          'valueTime': 15000 / 1000
        };

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(template);
      }
    }, 15000);
  }

  setFindLayers(scenes) {
    return map(scenes, (scene) => {
      return scene.layers;
    });
  }

  created() {
    Store.registerModule('stage', StageModule);
  }

  mounted() {
    this.$store.dispatch('stage/init').then((context) => {
      const currentSceneID = this.$route.query.sceneId;
      const startLayers = this.setFindLayers(
        filter(context.stage.scenes, { order: 0 }),
      );
      const matchScene = find(context.stage.scenes, { id: currentSceneID });

      this.sendGTMModuleView(
        currentSceneID ? matchScene.layers : startLayers[0],
      );
      this.sendGTMModuleTime();
    });
  }

  private destroyed() {
    Store.unregisterModule('stage');
  }
}
